export function initBlogDetailsShare() {
    const copyBtn = document.querySelector('.js-copy-link');

    if (copyBtn) {
        copyBtn.addEventListener('click', function () {
            const url = this.getAttribute('data-link');

            navigator.clipboard.writeText(url)
                .then(() => {
                    const tooltip = this.closest('.tmp-blogdetail__share-icon-wrapper')
                                       .querySelector('.copy-tooltip');
                    tooltip.classList.add('show');

                    setTimeout(() => {
                        tooltip.classList.remove('show');
                    }, 2000);
                })
                .catch(err => {
                    console.error('Copy failed', err);
                });
        });
    }
}